let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eG60v")).then(() => parcelRequire('i6O3K'));